import { render, staticRenderFns } from "./FaturamentoTab.vue?vue&type=template&id=0b639600"
import script from "./FaturamentoTab.vue?vue&type=script&lang=js"
export * from "./FaturamentoTab.vue?vue&type=script&lang=js"
import style0 from "./FaturamentoTab.vue?vue&type=style&index=0&id=0b639600&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports